import { Injectable } from '@angular/core';
import { tap, map, mapTo, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LogService } from '@ecosure-suite/shared/util-logging';
import { JwtService } from '@ecosure-suite/shared/util-auth';
import { User, Token } from './+state/auth.reducer';
import { KeycloakAuthApiService } from '@ecosure-suite/shared/data-access';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as forge from 'node-forge';
import * as JsEncryptModule from'jsencrypt';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgxrc8rSN2lh3ugI8odD2
  JkcOOGT7XLytVklQ9W26UkQgTD8djbTserSPgv/uhekW3GC5ZZ0GdI3+ZZ6PfEZC
  JVrApCKB6W1f/kZoRzZeIpz7RMZVL6AyoIu72/WmFwr0y2/V8emYXyK9FZCGDJmQ
  LTR3bUqfB1Tizmv9sixRSmPP1mlc2betTi/kqFwo7anVCUh/WbC5Ac+xgGRBLh0V
  F45zWtrMOfbcUpG3nKjIJSRUP3ejsmYvGEbS1ncezBJd+OG5aHxEI7ncA6OSL8Eq
  InDp0c+LQh1OlzABlz67jIV/Zo14yK1t+Xn9aMsLBHSx3290tsZPPf0omHs50cgf
  aQIDAQAB
  -----END PUBLIC KEY-----`

  constructor(
    private apiService: KeycloakAuthApiService,
    private logService: LogService,
    private jwtService: JwtService,
    private permissionsService: NgxPermissionsService,
    private rolesService: NgxRolesService,
    private http: HttpClient
  ) { }

  /**
   * Direct Login
   *
   */
//  login({
//     username,
//     password
//   }: {
//     username: string;
//     password: string;
//   }): Observable<any> {

//     var rsa = forge.pki.publicKeyFromPem(this.publicKey);
//     var encryptedUsername = window.btoa(rsa.encrypt(username));
//     var encryptedPassword = window.btoa(rsa.encrypt(password));

//     return this.apiService.login({username: encryptedUsername, password: encryptedPassword})
//       .pipe(
//         map(data => {
//           const login_token = Object.assign({}, data);
//           this.setAuth(login_token['access_token'])
//           sessionStorage.setItem(this.REFRESH_TOKEN, login_token['refresh_token']);
//         }),
//         catchError(err => err.error === 'invalid_grant' || '400' ? err.error_description : null)
//       );
//   }


  /**
   * * LOGIN USING KEYCLOAK OpenID Connect, OAuth 2.0
   */
  login({
    username,
    password
  }: {
    username: string;
    password: string;
  }): Observable<any> {
    const body = new HttpParams({
      fromObject: {
        'username': username,
        'password': password,
        'client_id': 'ecosure-app',
        'grant_type': 'password'
      }
    });
    var rsa = forge.pki.publicKeyFromPem(this.publicKey);
        var encryptedUsername = window.btoa(rsa.encrypt(username));
        var encryptedPassword = window.btoa(rsa.encrypt(password));
    
    return this.apiService.key_post(`/token`, body)
      .pipe(
        map(data => {
          const login_token = Object.assign({}, data);
          this.setAuth(login_token['access_token'])
          sessionStorage.setItem(this.REFRESH_TOKEN, login_token['refresh_token']);
        }),
        catchError(err => err.error === 'invalid_grant' || '400' ? err.error_description : null)
      );
  }

  /**
   * * GET USER DETAILS AND ROLES FROM KEYCLOAK
   */

  get(): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Accept': 'application/json',
      }
    ).append('Authorization', `Bearer ${this.jwtService.getToken()}`)

    const options = { headers: headers }

    return this.apiService.key_get(`/userinfo`, options)
      .pipe(map(data => {
        const user_details = new Map(Object.entries(data));
        if (user_details.has('sub')) {
          return {
            userId: user_details.get('sub'),
            username: user_details.get('preferred_username'),
            email: user_details.get('email'),
            roles: user_details.get('roles'),
            groups: user_details.get('groups')
          }
        }
      }),
        tap(user => {
          this.instantiateNgxPermissions(user)
        }))
  }


  private instantiateNgxPermissions(user: any) {
    this.permissionsService.loadPermissions(user.groups);
    this.permissionsService.loadPermissions(user.roles);
    this.rolesService.addRoles(
      Object.assign({}, ...user.groups.map(group => ({ [group]: user.roles })))
    );
  }

  private setAuth(user: any) {
    this.jwtService.setToken(user);
  }

  purgeAuth(): void {
    this.jwtService.destroyToken();
    this.permissionsService.flushPermissions();
  }
}
